<template>
    <div>
        <v-checkbox
                v-for="reason in reasons" :key="reason.property"
                v-model="value[reason.property]"
                :label="reason.label"
                dense
        />
        <v-textarea
                v-model="value.notes"
                label="Notes"
                hint="For our own records write the details of a change"
        />

    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object
            },
        },
        data() {
            return {
                reasons: [
                    {label: 'Course Change', property: 'courseChange'},
                    {label: 'Level Change', property: 'levelChange'},
                    {label: 'Date Change', property: 'dateChange'},
                    {label: 'Price Change', property: 'priceChange'},
                    {label: 'Delegate Change (Names or Amount)', property: 'delegateChange'},
                    {label: 'PO Reference Change', property: 'poRefChange'},
                    {label: 'Printed Notes Change', property: 'printedNotesChange'},
                ]
            }
        },
    }
</script>

<style scoped>

</style>